module.exports = __webpack_public_path__ + "static/media/dcc_loader.4831fa54.svg";